<template lang="pug">
div
  v-flex.text-xs-right(@click='C.trigger.setCompletion', xs1, v-if='C.state.containerSection.completion && C.state.$isEditable')
    v-btn(fab, small, icon, color='secondary', dark)
      v-icon(small)
        | {{ C.state.interstitial ? "blur_on" : "check" }}
  v-flex.text-xs-right(@click='C.trigger.setCompletion', xs1, v-if='!C.state.containerSection.completion && C.state.$isEditable')
    v-btn(flat, icon, outline, color='secondary')
      v-icon(small)
        | {{ C.state.interstitial ? "blur_on" : "check" }}
  v-icon.ml-2(v-if='C.state.containerSection.completion && !C.state.$isEditable')
    | check_circle
</template>
<script>
  import tools from '../../assets/tools.js'

  import axios from '../../../node_modules/axios/dist/axios.js'
  import _ from '../../../node_modules/underscore/underscore-min.js'

  export default {
    components: {},
    props: ['section-id', 'section-item', 'is-editable', 'component-id', 'save-callback'],
    data () {
      return {
        C: {
          state: {
            containerSection: {},
            interstitial: false
          },
          trigger: {
            setCompletion: () => {
              var component = this

              var submitItem = {
                section_name: component.C.state.containerSection.$key,
                completion: !component.C.state.containerSection.completion
              }

              if (component.C.state.$componentID) {
                submitItem.component_id = component.C.state.$componentID
              } else {
                submitItem.invention_id = parseInt(component.$route.params.id)
              }

              component.C.state.interstitial = true

              axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/container_sections/update_completion`, submitItem)
                .then(function (response) {
                  var completionItem = (response && response.data && response.data.data && response.data.data.invention && response.data.data.invention.container_section && response.data.data.invention.container_section[component.C.state.containerSection.$key] && response.data.data.invention.container_section[component.C.state.containerSection.$key]) || {}
                  var completionResults

                  if (component.C.state.$componentID) {
                    var completionComponents = (completionItem.components) || []

                    var containerComponentResults = (_.find(completionComponents, function (containerComponentItem) {
                      return containerComponentItem.id === component.C.state.$componentID
                    })) || {}

                    completionResults = (containerComponentResults.completion) || false
                  } else {
                    completionResults = (completionItem.completion) || false
                  }

                  component.C.state.containerSection.completion = completionResults

                  component.C.trigger.saveCallback()

                  component.C.state.interstitial = false
                })
                .catch(function (errorResponse) {
                  tools.alert({
                    type: 'error',
                    errorResponse: errorResponse
                  })

                  component.C.state.interstitial = false
                })
            },
            saveCallback: _.noop
          }
        }
      }
    },
    created () {
      var component = this

      component.C.state.containerSection = component.sectionItem
      component.C.state.containerSection.$key = component.sectionId
      component.C.state.$isEditable = component.isEditable
      component.C.state.$componentID = component.componentId
      component.C.trigger.saveCallback = component.saveCallback || _.noop
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Inventions/CompletionCheck.vue